<mat-form-field class="full-width">
  <ng-container *ngIf="model.label" ngProjectAs="mat-label">
    <mat-label [innerHTML]="model.label"></mat-label>
  </ng-container>
  <input
    matInput
    [id]="model.id"
    [formControl]="selectFilterCtrl"
    [placeholder]="model.placeholder"
    [matAutocomplete]="auto"
    [required]="model.required"
    (blur)="onSelectFilterBlur()"
    data-test="gsm-select-filter_input"
  />
  <div class="mat-select-arrow autocomplete-arrow" matSuffix></div>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" data-test="gsm-select-filter_auto">
    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
      <span>{{ option.label }}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-hint *ngIf="model.hint !== null" align="start" [innerHTML]="model.hint"></mat-hint>
  <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
</mat-form-field>
